import langdisplay from '@/apps/display/lang/';
export default {
	langdisplay: langdisplay,
	display: false,
	lateralShow: true, // oculto= true, mostar = false
	displayEdit:[],	
}
